"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../decorators");
var _styles = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//styled-components

var SpinnerComponent = function SpinnerComponent(_ref) {
  var center = _ref.center,
    centerX = _ref.centerX,
    centerY = _ref.centerY,
    centerAbs = _ref.centerAbs,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '2rem' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_styles.Spinner, {
    "data-testid": "spinner",
    className: "spinner",
    role: "alert",
    "aria-busy": "true",
    "aria-label": "Loading"
  }, /*#__PURE__*/_react["default"].createElement(_styles.Circle, {
    center: center,
    centerX: centerX,
    centerY: centerY,
    centerAbs: centerAbs,
    color: color,
    size: typeof size === 'number' ? "".concat(size, "px") : size
  }));
};
var _default = exports["default"] = (0, _decorators.styleable)(SpinnerComponent);
//# sourceMappingURL=index.js.map